import { ComponentPropsWithoutRef, FC } from 'react';
import { twJoin } from 'tailwind-merge';

import Icon from 'molecules/Icon';

export interface BulletProps extends ComponentPropsWithoutRef<'div'> {
  isBullet?: boolean;
  className?: string;
}

const Bullet: FC<BulletProps> = ({ children, id, isBullet, className = 'text-primary-1000' }) => (
  <li key={id} className={twJoin(isBullet ? 'items-center' : '', 'flex gap-2')}>
    <div
      className={twJoin(
        isBullet ? 'size-[10px] sm:size-3' : 'size-6 sm:size-7',
        'flex shrink-0 text-primary-1000 dark:text-primary-300',
      )}
    >
      <Icon
        icon={isBullet ? 'bullet' : 'circle-check'}
        size={24}
        className={`${className} size-full rounded-full stroke-2`}
      />
    </div>
    <div className="text-sm sm:text-md">{children}</div>
  </li>
);

export default Bullet;
